import _extends from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _slicedToArray from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _taggedTemplateLiteral from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _toConsumableArray from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
var _excluded = ["checked", "defaultChecked", "label", "onChange", "containerProps", "textProps", "url"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

import React, { useCallback } from "react";
import { createShouldForwardProp, props } from "@styled-system/should-forward-prop";
import { color, compose, css, layout, size, space, styled, system, themeGet, typography } from "@catchoftheday/theme";
import { useControlled } from "@catchoftheday/utilities";
import { Box } from "../Box";
import { jsx as ___EmotionJSX } from "@emotion/react";
var shouldForwardProp = createShouldForwardProp([].concat(_toConsumableArray(props), ["checked", "checkedBackgroundColor", "checkedColor", "hoverBackgroundColor", "hoverColor"]));
var hoverProps = system({
  hoverBackgroundColor: {
    property: "backgroundColor",
    scale: "colors"
  },
  hoverColor: {
    property: "color",
    scale: "colors"
  }
});
var checkedProps = system({
  checkedBackgroundColor: {
    property: "backgroundColor",
    scale: "colors"
  },
  checkedColor: {
    property: "color",
    scale: "colors"
  }
});
var styleProps = compose(space, layout, color, typography, size);
var PillContainer = styled(Box, {
  shouldForwardProp: shouldForwardProp
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n  border-radius: ", ";\n  display: inline-block;\n  font-size: 1rem;\n  padding: 10px 30px;\n  position: relative;\n  text-align: center;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-decoration: none;\n  ", "\n  ", "\n  ", "\n"])), themeGet("colors.ui.backgroundColor"), themeGet("colors.typography.text"), themeGet("radii.rounded"), styleProps, function (props) {
  return !props.checked && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      &:hover {\n        ", "\n      }\n    "])), hoverProps(props));
}, function (props) {
  return props.checked && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      ", "\n    "])), checkedProps(props));
});
export var BasePill = styled("input")(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  appearance: none;\n  cursor: pointer;\n  height: 100%;\n  left: 0;\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  z-index: 1;\n"])));
export var PillText = styled("span")(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  white-space: nowrap;\n"])));
export var Pill = function Pill(_ref) {
  var checkedProp = _ref.checked,
      defaultChecked = _ref.defaultChecked,
      label = _ref.label,
      onChange = _ref.onChange,
      containerProps = _ref.containerProps,
      textProps = _ref.textProps,
      url = _ref.url,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var _useControlled = useControlled(defaultChecked, checkedProp),
      _useControlled2 = _slicedToArray(_useControlled, 2),
      checked = _useControlled2[0],
      setChecked = _useControlled2[1];

  var handleOnChange = useCallback(function (e) {
    setChecked(e.target.checked);

    if (typeof onChange === "function") {
      onChange(e);
    }
  }, [onChange, setChecked]);
  return url ? ___EmotionJSX(PillContainer, _extends({
    as: "a",
    checked: checked,
    href: url
  }, containerProps), ___EmotionJSX(PillText, textProps, label)) : ___EmotionJSX(PillContainer, _extends({
    checked: checked
  }, containerProps), ___EmotionJSX(PillText, textProps, label), ___EmotionJSX(BasePill, _extends({
    "aria-label": "Navigation Pill",
    type: "checkbox",
    onChange: handleOnChange
  }, otherProps)));
};
Pill.displayName = "Pill";
PillContainer.defaultProps = {
  hoverColor: "typography.text",
  hoverBackgroundColor: "#DDDDDD",
  checkedColor: "white",
  checkedBackgroundColor: "secondary"
};
export default Pill;